<div class="d-flex justify-content-between mb-1">
  <div>
    <span class="shift-text d-block">
      {{ 'page.shift_timeline.add_transfer.previous_shift' | translate }}
    </span>
    <span class="shift-text d-block">
      {{ previousShift.endDateTime | localizedDateTimeFormat }}
    </span>
  </div>
  <div class="text-end">
    <span class="shift-text d-block">
      {{ 'page.shift_timeline.add_transfer.next_shift' | translate }}
    </span>
    <span class="shift-text d-block">
      {{ nextShift.startDateTime | localizedDateTimeFormat }}
    </span>
  </div>
</div>

<div class="d-flex justify-content-between mb-3">
  <div class="time-difference"></div>
  <div class="d-flex">
    <wilson-preview-card
      [startLocation]="previousShift.startLocation"
      [endLocation]="
        selectedTransferType === TransferType.Previous
          ? nextShift.startLocation
          : previousShift.endLocation
      "
      [startDateTime]="previousShift.startDateTime"
      [endDateTime]="
        selectedTransferType === TransferType.Previous
          ? previousShiftTransferEndDateTime
          : previousShift.endDateTime
      "
      [isTransferCard]="
        selectedDuration && selectedTransferType === TransferType.Previous
          ? true
          : false
      "
    ></wilson-preview-card>
  </div>
  @if (selectedTransferType === TransferType.New) {
    <div class="d-flex">
      <wilson-preview-card
        [startLocation]="previousShift.endLocation"
        [endLocation]="nextShift.startLocation"
        [startDateTime]="newShiftTransferStartDateTime"
        [endDateTime]="newShiftTransferEndDateTime"
        [isTransferCard]="false"
      ></wilson-preview-card>
    </div>
  }
  <div class="d-flex">
    <wilson-preview-card
      [startLocation]="
        selectedTransferType === TransferType.Next
          ? previousShift.endLocation
          : nextShift.startLocation
      "
      [endLocation]="nextShift.endLocation"
      [startDateTime]="
        selectedTransferType === TransferType.Next
          ? nextShiftTransferStartDateTime
          : nextShift.startDateTime
      "
      [endDateTime]="nextShift.endDateTime"
      [isTransferCard]="
        selectedDuration && selectedTransferType === TransferType.Next
          ? true
          : false
      "
    ></wilson-preview-card>
  </div>
</div>
